import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {SubscriptionModel} from '../../../api/entity/subscription.model';
import {SubscriptionConverter} from '../../../api/entity/converter/subscription.converter';
import {SubscriptionDataService} from './subscriptionData.service';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionDataServiceAdapter extends AbstractDataServiceDtoAdapter<SubscriptionModel, SubscriptionConverter> {
    constructor(dataService: SubscriptionDataService, converter: SubscriptionConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): SubscriptionModel {
        return new SubscriptionModel();
    }
}
